<div class="flex w-full flex-col gap-4 py-4">
	@if (showAdvancedHeader) {
		@let total = advancedTotalCount$ | async;
		<div class="flex flex-wrap items-center justify-between gap-x-3 gap-y-2 px-4 py-3">
			<div class="flex min-w-0 flex-wrap items-center gap-2">
				<span class="text-xl font-bold leading-snug text-mainColor"> Filtry dodatkowe </span>
				@if ((total ?? 0) > 0) {
					<span
						class="inline-flex h-6 min-w-[1.5rem] shrink-0 items-center justify-center rounded-full bg-accentColorBg15 px-2 text-sm font-bold leading-none text-mainColor"
					>
						{{ total }}
					</span>
				}
			</div>
			@if ((total ?? 0) > 0) {
				<button
					type="button"
					class="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-medium leading-none text-gray transition hover:text-mainColor"
					(click)="clearAllAdvancedFilters($event)"
				>
					<i class="fa-solid fa-arrow-rotate-left text-xs" aria-hidden="true"></i>
					Wyczyść
				</button>
			}
		</div>
	}

	@for (item of filters; track i; let i = $index) {
		<app-top-search-advanced-filter-wrapper
			[title]="item.text"
			[iconClass]="getIconClass(item)"
			[filterMode]="item.id"
			(cleared)="onAdvancedFilterChange()"
		>
			<app-top-search-dropdown-item
				[mode]="item.id"
				[inlineLayout]="true"
				(valueChange)="onAdvancedFilterChange()"
			></app-top-search-dropdown-item>
		</app-top-search-advanced-filter-wrapper>
	}
</div>
